import React from 'react';

export default function FileLink({ newFile, savedFile }) {
  if (newFile) {
    return <a href={URL.createObjectURL(newFile)} target='_blank'>{newFile.name}</a>;
  } else if (savedFile) {
    return <a href={savedFile.url} target='_blank'>{savedFile.name}</a>;
  } else {
    return null;
  }
}
